module.exports = __webpack_public_path__ + "static/media/pholidoptera_griseoaptera_004_APA.f30b3472.png";